import React, { CSSProperties, forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './FormGrid.module.scss';

export interface IFormGridProps {
    children?: ReactNode;
    columns: number[];
    rows?: number;
    className?: string;
    style?: CSSProperties;
}

export const FormGrid = forwardRef<HTMLDivElement, IFormGridProps>(
    ({ columns, children, rows, className, style }, ref) => {
        return (
            <div
                ref={ref}
                className={classNames(styles.grid, className)}
                style={{
                    ...style,
                    gridTemplateColumns: columns.map((colWidth) => `minmax(0, ${colWidth}fr)`).join(' '),
                    gridTemplateRows: `repeat(${rows || 1}, auto)`,
                }}
            >
                {children}
            </div>
        );
    },
);

FormGrid.displayName = 'FormGrid';
